import packageJson from '../../../../package.json';

let ver = packageJson.version;

export const version = ver;
